<template>
  <v-navigation-drawer
    hide-overlay
    :mini-variant.sync="miniVariantValue"
    v-model="activeMainMenuValue"
    absolute
    overflow
    app
  >
    <v-list
      class="pa-0"
      expand
    >

      <v-list-tile>
        <global-search></global-search>
      </v-list-tile>

      <template v-for="item in menu">
        <v-list-group
          :key="item.name"
          v-if="item.children.length"
          :value="item.menuCollapsed ? false : true"
        >
          <v-list-tile
            slot="activator"
            exact
            :to="{ name: item.name }"
            :exact-active-class="'success--text'"
            :active-class="'success--text'"
          >
            <v-list-tile-action>
              <notificationsBadge v-if="item.meta.isNotificationBadge === true"/>
              <v-icon v-else>
                {{ item.meta.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.meta.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in item.children"
            :key="subItem.name"
            exact
            :exact-active-class="'success--text'"
            :to="{ name: subItem.name }"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ subItem.meta.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
          :to="{ name: item.name }"
          :key="item.name"
          :exact-active-class="'success--text'"
          exact
          v-else
        >
          <v-list-tile-action>
            <notificationsBadge v-if="item.meta.isNotificationBadge === true"/>
            <v-icon v-else>
              {{ item.meta.icon }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.meta.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { menuItems } from '@/router/ROUTES';
import globalSearch from '@/components/form/globalSearch';
import notificationsBadge from '@/components/trial/notificationsBadge';

export default {
  name: 'mainMenu',
  props: {
    activeMainMenu: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    globalSearch,
    notificationsBadge,
  },
  data() {
    return {
      miniVariantValue: false,
    };
  },
  computed: {
    activeMainMenuValue: {
      get() {
        return this.activeMainMenu;
      },
      set(value) {
        this.$emit('update:activeMainMenu', value);
      },
    },
    menu() {
      const slug = this.currentGroup.slug || 'PM';
      const checkAllowedGroups = this.checkAllowedGroups(slug);
      return JSON.parse(JSON.stringify(menuItems))
        .filter(checkAllowedGroups)
        .map(item => {
          if (item.children) {
            item.children = item.children.filter(v => v.path && checkAllowedGroups(v));
          }
          return item;
        });
    },
  },
  methods: {
    checkAllowedGroups(slug) {
      return (item) => item.meta.allowedGroups
        ? item.meta.allowedGroups.includes(slug)
        : item.menuItem;
    },
  },
};
</script>
